import { ref } from 'vue'
import type { Ref } from 'vue'
import type { MenuPublic } from '../entities/MenuPublic'
import { PUBLIC_MENU } from '../entities/MenuType'
import { contentCall } from './useMenu'

export const useMenuPublic = async () => {
  const route = useRoute()

  const menuAdapter = (rawData: any): MenuPublic => {
    const selectedItemId = route.meta.publicMenuItem

    const parsedData: MenuPublic = rawData.map((item: any) => {
      if (item.id === selectedItemId) {
        return {
          id: item.id,
          name: item.name,
          href: item.href,
          icon: item.icon,
          selected: true,
        }
      } else {
        return item
      }
    })

    return parsedData
  }

  const data = await contentCall(PUBLIC_MENU, false)
  const dataAdapted = menuAdapter(data)
  const MenuPublicInstance: Ref<MenuPublic> = ref(dataAdapted)

  return { MenuPublicInstance }
}
